// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M17.6747 13.2421C17.1445 14.4959 16.3153 15.6006 15.2596 16.4599C14.2038 17.3191 12.9537 17.9067 11.6184 18.1711C10.2831 18.4356 8.90337 18.3689 7.59981 17.977C6.29624 17.585 5.10854 16.8797 4.14053 15.9227C3.17253 14.9657 2.4537 13.7861 2.04688 12.4871C1.64006 11.1881 1.55765 9.8092 1.80685 8.47099C2.05605 7.13278 2.62926 5.87599 3.47639 4.81049C4.32352 3.74499 5.41875 2.90323 6.66635 2.3588M17.6987 6.81144C18.0323 7.61682 18.2369 8.46827 18.3064 9.3345C18.3235 9.5485 18.3321 9.6555 18.2896 9.75188C18.2541 9.8324 18.1838 9.90859 18.1064 9.9504C18.0137 10.0005 17.8979 10.0005 17.6664 10.0005H10.6664C10.433 10.0005 10.3163 10.0005 10.2272 9.95505C10.1488 9.9151 10.085 9.85136 10.0451 9.77296C9.99969 9.68383 9.99969 9.56715 9.99969 9.3338V2.3338C9.99969 2.10224 9.99969 1.98646 10.0497 1.89378C10.0916 1.81636 10.1678 1.74604 10.2483 1.71054C10.3447 1.66805 10.4517 1.67663 10.6657 1.69378C11.5319 1.76323 12.3833 1.96787 13.1887 2.30147C14.1998 2.72026 15.1184 3.33409 15.8922 4.10791C16.6661 4.88173 17.2799 5.80039 17.6987 6.81144Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const IconChart = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconChart;
